export enum ChallengeThemes {
    STANDARD = 'STANDARD',
    MOVEMENT = 'MOVEMENT',
    HYDRATION = 'HYDRATION',
    SLEEP = 'SLEEP',
    RESET = 'RESET'
}
